import script from "./my.vue?vue&type=script&lang=ts&setup=true"
export * from "./my.vue?vue&type=script&lang=ts&setup=true"

import "./my.vue?vue&type=style&index=0&id=3a747340&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a747340"]])

export default __exports__